import * as EventListener from "../common/helpers/event-listener";

const clickShowSidebar = () => {
    EventListener.click("show-sidebar", (element) => {
        showHideSidebar();
        element.disabled = false;
    });
};

const clickHideSidebar = () => {
    EventListener.click("hide-sidebar", (element) => {
        showHideSidebar();
        element.disabled = false;
    });
};

const showHideSidebar = () => {
    const hiddenClass = "show";
    const hiddenBlock = document.querySelector(".user-sidebar");

    if (hiddenBlock.classList.contains(hiddenClass)) {
        hiddenBlock.classList.remove(hiddenClass);
    } else {
        hiddenBlock.classList.add(hiddenClass);
    }
};

clickShowSidebar();
clickHideSidebar();
